import { QueryClient } from '@tanstack/vue-query'

// Defaults match the app's pre-TanStack behavior. Loosen them per query, deliberately.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
